<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
        {
        "num_cand": "U2FsdGVkX19zIgzt0TyHp1pyqQr3H4FjXNHpfGP9iFg=",
        "cpf": "U2FsdGVkX1/I9U47qP6Gbuf1QIC/8vN7PHXO4GpqFd4="
      }, {
        "num_cand": "U2FsdGVkX1/PdsvA5UAkcDXAVWZhaFwnopc/JorPn4o=",
        "cpf": "U2FsdGVkX1+qexDql90YiLNAjpzAPGPn7aRgSZ+5I90="
      }, {
        "num_cand": "U2FsdGVkX18vBeXbOLz9mPjs0q3uyNXTxKkwzaPoMd4=",
        "cpf": "U2FsdGVkX1+Lu1qWGjpV59Cx1cgsbwkjWvVwJfs01HQ="
      }, {
        "num_cand": "U2FsdGVkX1+V5xso1vgj4hUsO2bDnAytpYroiKQUE4U=",
        "cpf": "U2FsdGVkX188Mh3+lInrxSNxInKtDeoBHAU3EjBta+0="
      }, {
        "num_cand": "U2FsdGVkX1+Em0vMISp5Zu3BIzyHD5OHd78EtyuY3T0=",
        "cpf": "U2FsdGVkX1/jzlvhcMfjROi94xAFZEL6ynFAaDKw1GM="
      }, {
        "num_cand": "U2FsdGVkX1/UKgD2HMIJ46FFdClCBM40obKb9CB8afM=",
        "cpf": "U2FsdGVkX1+rIf7tUZ/4+gVaZbL3gqyyH31I0Wu6yx0="
      }, {
        "num_cand": "U2FsdGVkX196syUwl74HQryI5wNYfdk0KvEKrOvJQNY=",
        "cpf": "U2FsdGVkX1+iEtTdPtZ9PXFqVMmYx4qefIYLWiketZ4="
      }, {
        "num_cand": "U2FsdGVkX1/ZRHdJyOwVngxHJDZRS4gNpcVP4xBUkCA=",
        "cpf": "U2FsdGVkX1+SUFgeaxNThEakhVyDfgIUNfBs2+ovPTg="
      }, {
        "num_cand": "U2FsdGVkX18hnQ8BoCZdvyE8F4OgQRqZDBLAGSaxhz8=",
        "cpf": "U2FsdGVkX1+Y+2U2c7XJvNUU7BlQsgnKan8dadW/aQo="
      }, {
        "num_cand": "U2FsdGVkX19CERlFPo86Z4Kk2NUknTxwTw8kgL5yb+I=",
        "cpf": "U2FsdGVkX1/rp4AqVVdJpNEKfGkRUduwH31/v2XDDiE="
      }, {
        "num_cand": "U2FsdGVkX19Cv8fJaIfFSwSHhpxxKdDVpdytak/pLa8=",
        "cpf": "U2FsdGVkX1+Xs39R9lZRmOordsmD4tzSZiFrPpeneVE="
      }, {
        "num_cand": "U2FsdGVkX1+l/prrAdsXjxgFJv7j+MVHSjixqvSHsgo=",
        "cpf": "U2FsdGVkX1+YQLCozFRg4tsGZ1vSt+Y5iXM8PPmjxzs="
      }, {
        "num_cand": "U2FsdGVkX1+01Mfvu25zAmx2S1rg6vapvvXuKD3HIe0=",
        "cpf": "U2FsdGVkX1+s4lxani+8dgTzVAuArY4t5jiV2l7ZYCs="
      }, {
        "num_cand": "U2FsdGVkX18PPV8CXApoEc/lvpDlB1zjMub+Uy+8hHE=",
        "cpf": "U2FsdGVkX1+j/PD7xK89H1eNsV7UCpHeHjrBXdzFBgs="
      }]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2206/2206_rec_ped_inse/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
